import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDialogs } from "../hooks/use-dialogs";
import useLivrariaModel from "../model/livraria";
import { Livraria } from "../types/general";
import useLivrariaStore from "../zustand/use-livraria-store";
import useLivroStore from "../zustand/use-livro-store";

export const ViewModelLivraria = () => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const livrariaIdParam = searchParams.get("livraria");

  const { resetState } = useLivroStore((state) => ({ resetState: state.resetState }))

  const {
    livrarias,
    selectedLivraria,
    selectedLivrariaId,
    setSelectedLivraria,
    setSelectedLivrariaId,
  } = useLivrariaStore();

  const {
    fetchLivrarias,
    createLivraria,
    updateLivrariaById,
    deleteLivrariaById
  } = useLivrariaModel();

  const {
    close,
    dialog,
    showConfirmation,
    showSuccess,
    showError,
    showWarning
  } = useDialogs();

  useEffect(() => {
    fetchLivrarias();
  }, [])

  // Select livraria for editing
  const selectLivraria = (livraria: Livraria) => {
    setSelectedLivraria(livraria);
  };

  // Clear selection
  const clearSelection = () => {
    setSelectedLivraria(undefined as any);
  };

  // Navigate to livros page for a livraria
  const goToLivros = (livrariaId: number) => {
    resetState();
    navigate(`/livros?livraria=${livrariaId}`);
  };

  const handleDeleteLivraria = (id: number) => {
    close();
    deleteLivrariaById(id, {
      response: () => {
        showSuccess({
          title: 'Sucesso',
          message: 'Disciplina removida com sucesso!'
        });
      },
      error: () => {
        showError({
          title: 'Erro',
          message: 'Ocorreu erro ao remover a disciplina!',
        })
      }
    })
  }

  const handleActionLivraria = (livraria: Livraria, action: 'add' | 'update') => {
    if (action === 'add') {
      createLivraria(livraria as any, {
        response: () => {
          showSuccess({
            title: 'Sucesso',
            message: 'Disciplina criada com sucesso!'
          });
        },
        error: (error) => {
          console.log(error)
          showError({
            title: 'Erro',
            message: 'Ocorreu erro ao criar a disciplina!',
          })
        }
      });
    } else {
      updateLivrariaById(livraria, {
        response: () => {
          showSuccess({
            title: 'Sucesso',
            message: 'Disciplina actualizada com sucesso!'
          });
        },
        error: () => {
          showError({
            title: 'Erro',
            message: 'Ocorreu erro ao actualizar a disciplina!',
          })
        }
      });
    }
  }

  return {
    // State
    livrarias,
    selectedLivraria,
    selectedLivrariaId,
    livrariaIdParam,
    // Actions
    fetchLivrarias,
    handleActionLivraria,
    handleDeleteLivraria,
    selectLivraria,
    clearSelection,
    goToLivros,
    navigate,
    // Dialogs
    dialog,
    showConfirmation,
    showSuccess,
    showError,
    showWarning,
  };
};
